import type { UploadFileResult } from '@revelio/data-access';

import { dashMetaFetch } from '../../../../../../shared/api/dash-meta-fetch';

export const uploadFileToStorage = async ({
  blob,
  fileName,
}: {
  blob: Blob;
  fileName: string;
}): Promise<UploadFileResult> => {
  const formData = new FormData();
  formData.append('file', blob, fileName);
  formData.append('fileName', fileName);

  const resp = await dashMetaFetch('/api/storage/upload?provider=onlyoffice', {
    method: 'POST',
    body: formData,
  });
  if (!resp.ok) {
    throw new Error('Failed to upload file to storage');
  }
  const data = (await resp.json()) as UploadFileResult;
  return data;
};
